import { defineMessages } from "@formatjs/intl"
import type { VideoStatusIndicator } from "./VehicleMediaListView"

export const videoStatusMessages = defineMessages<VideoStatusIndicator>({
	COMPLETE: {
		defaultMessage: "Complete",
		id: "vehicleMediaList.videoStatus.complete",
	},
	WARNING: {
		defaultMessage: "Please add a video of the vehicle",
		id: "vehicleMediaList.videoStatus.warning",
	},
})
